import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import StarIcon from "@mui/icons-material/Star";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

function CertificationInfo() {
  const certifications = [
    {
      title: "Doctor of Medicine (MD) in Neurology",
      institution: "Government Medical College, Thiruvananthapuram",
      date: "May 2011",
      achievements:
        "Successfully completed MD in Neurology, specializing in clinical neurology.",
      certificationNumber: "GMC-MD-NEURO-20110511",
    },
    {
      title: "Doctorate in Neurology (DM)",
      institution: "Amrita Institute of Medical Sciences, Kochi",
      date: "August 2014",
      achievements:
        "Completed DM in Neurology with extensive research on neurological disorders.",
      certificationNumber: "AMRITA-DM-NEURO-20140814",
    },
    {
      title: "Fellowship in Epilepsy and Neurogenetics",
      institution:
        "National Institute of Mental Health and Neurosciences (NIMHANS), Bangalore",
      date: "November 2016",
      achievements:
        "Specialized in epilepsy and neurogenetic disorders, contributing to several clinical trials.",
      certificationNumber: "NIMHANS-FELLOWSHIP-20161115",
    },
    {
      title: "Neurology Board Certification",
      institution: "Indian Board of Neurology",
      date: "January 2017",
      achievements:
        "Certified neurologist, specializing in complex neurological conditions.",
      certificationNumber: "IBN-NBC-20170122",
    },
    {
      title: "Basic Life Support (BLS)",
      institution: "Indian Red Cross Society",
      date: "June 2015",
      achievements:
        "Certified in Basic Life Support to handle emergency situations in clinical settings.",
      certificationNumber: "IRCS-BLS-20150618",
    },
  ];

  return (
    <Grid container spacing={3}>
      {certifications.map((cert, index) => (
        <Grid item xs={12} key={index}>
          <Card
            variant="outlined"
            sx={{ borderRadius: "10px", minHeight: "150px" }}
          >
            <CardContent>
              <Typography
                sx={{
                  fontFamily: "Geist, sans-serif",
                  letterSpacing: `0.5px`,
                  fontSize: "24px",
                  color: "#333",
                  fontWeight: "600",
                }}
                mb={2}
              >
                {cert.title}
              </Typography>
              <Grid container spacing={2} p={2}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Box display="flex" alignItems="flex-start">
                    <Box mr={2}>
                      <SchoolIcon sx={{ fontSize: 24, color: "#71717a" }} />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "14px",
                          color: "#71717a",
                          fontWeight: "500",
                        }}
                      >
                        Certification Title
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "16px",
                          color: "#09090B",
                          fontWeight: "400",
                        }}
                      >
                        {cert.title}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Box display="flex" alignItems="flex-start">
                    <Box mr={2}>
                      <LocalHospitalIcon
                        sx={{ fontSize: 24, color: "#71717a" }}
                      />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "14px",
                          color: "#71717a",
                          fontWeight: "500",
                        }}
                      >
                        Institution
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "16px",
                          color: "#09090B",
                          fontWeight: "400",
                        }}
                      >
                        {cert.institution}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <Box display="flex" alignItems="flex-start">
                    <Box mr={2}>
                      <StarIcon sx={{ fontSize: 24, color: "#71717a" }} />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "14px",
                          color: "#71717a",
                          fontWeight: "500",
                        }}
                      >
                        Achievements
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "16px",
                          color: "#09090B",
                          fontWeight: "400",
                        }}
                      >
                        {cert.achievements}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={12} lg={2}>
                  <Box display="flex" alignItems="flex-start">
                    <Box mr={2}>
                      <AccessTimeIcon sx={{ fontSize: 24, color: "#71717a" }} />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "14px",
                          color: "#71717a",
                          fontWeight: "500",
                        }}
                      >
                        Date Issued
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "16px",
                          color: "#09090B",
                          fontWeight: "400",
                        }}
                      >
                        {cert.date}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{ borderTop: "1px solid lightgrey" }}
                  mt={2}
                >
                  <Box display="flex" alignItems="flex-start">
                    <Box mr={2}>
                      <AssignmentIcon sx={{ fontSize: 24, color: "#71717a" }} />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "14px",
                          color: "#71717a",
                          fontWeight: "500",
                        }}
                      >
                        Certification Number
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          letterSpacing: "0.5px",
                          fontSize: "16px",
                          color: "#09090B",
                          fontWeight: "400",
                        }}
                      >
                        {cert.certificationNumber}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default CertificationInfo;
